import Offers from '../../modules/Offers/Offers';

function PageOffers() {
    return <><Offers/></>
}

export default PageOffers;
